import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import LandingPageLayout from '@/layout/LandingPageLayout'
import AuthLayout from '@/layout/AuthLayout'
import { store } from "./store";

Vue.use(Router)

 let router = new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'LandingPageNew',
      component: LandingPageLayout,
      children: [
        {
          path: '/LandingPageNew',
          name: 'LandingPageNew',
          component: () => import(/* webpackChunkName: "demo" */ './views/LandingPageNew.vue')
        },
      ]
    },
    {
      path: '/design',
      redirect: 'design',
      component: DashboardLayout,
      children: [
        {
          path: '/design',
          name: 'design',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Design.vue')
        },
        {
          path: '/commercial',
          name: 'commercial',
          component: () => import(/* webpackChunkName: "demo" */ './views/Commercial.vue')
        },
        {
          path: '/reporting',
          name: 'reporting',
          component: () => import(/* webpackChunkName: "demo" */ './views/Reporting.vue')
        },
        {
          path: '/collaboration',
          name: 'collaboration',
          component: () => import(/* webpackChunkName: "demo" */ './views/Collaboration.vue')
        },
        {
          path: '/management',
          name: 'management',
          component: () => import(/* webpackChunkName: "demo" */ './views/Management.vue')
        },
        {
          path: '/innovation',
          name: 'innovation',
          component: () => import(/* webpackChunkName: "demo" */ './views/Innovation.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        }
      ]
    },
  ]
})

router.beforeResolve((to, from, next) => {
  var categoriesList = [
    "/commercial",
    "/reporting",
    "/design",
    "/collaboration",
    "/management",
    "/innovation"
  ]
  if (categoriesList.includes(to.path)) {
    var category = to.path.replace("/","")
    store.commit("sideBarStore/setSelectedZone", category)
    store.commit("sideBarStore/setCategoriesFromZone", category)
    if (Object.keys(store.state.sideBarStore.selectedLine).length == 0) {
      store.commit("sideBarStore/setSelectedLine", "west")
      store.commit("sideBarStore/setSelectedStations", store.state.sideBarStore.selectedLine.code)
    }
    if (Object.keys(store.state.sideBarStore.selectedPortfolio).length == 0) {
      store.commit("sideBarStore/setSelectedPortfolio", "passenger_service")
      store.commit("sideBarStore/setSelectedProjects", store.state.sideBarStore.selectedPortfolio.code)
    }
  }
  next()
})
export default router;
